import {defineStore} from "pinia";
import useCrudStore from "@/store/composables/crud";
import environment from "@/environment";
import {ref} from "vue";
import {useUserSettings} from "@/composables/user-settings";
import http from "@/tools/http-client";

export const useClubSignUpStore
    = defineStore('clubSignUpStore', () => {

    const clubSignUpUrl = environment.appConfig.baseApiUrl + "club-signup";
    const crud = useCrudStore(clubSignUpUrl);

    const firstName = ref(null)
    const lastName = ref(null)
    const email = ref(null)
    const phone = ref(null)
    const city = ref(null)
    const info = ref(null)
    const signup = ref(null)

    function fillFromUserSettings() {
        const userSettings = useUserSettings();
        console.log('User settings', JSON.stringify(userSettings));
        firstName.value = userSettings.first_name;
        lastName.value = userSettings.last_name;
        email.value = userSettings.email;
        phone.value = userSettings.phone;
        city.value = userSettings.city;
        info.value = userSettings.info;
    }

    async function clubSignUp(consents) {
        console.log("clubSignUp invoked", firstName.value, lastName.value);
        crud.startLoading();
        try {
            const params = {
                first_name: firstName.value,
                last_name: lastName.value,
                email: email.value,
                phone: phone.value,
                city: city.value,
                info: info.value,
                accept_club_terms: !!consents?.acceptClubTerms,
                accept_personal_data: !!consents?.acceptPersonalData,
            };
            const resp = await http.post(crud.endpoint.value, params);
            console.log('Success', JSON.stringify(resp.data))
            crud.clearLoading();
            if (resp.data.status === 'success') {
                signup.value = resp.data.signup || null;
                return signup.value;
            }
            crud.setError(resp.data.message);
            return null;
        } catch (e) {
            crud.setError(e);
            return null;
        }
    }

    async function loadClubSignUp() {
        crud.startLoading();
        try {
            const resp = await http.get(crud.endpoint.value);
            signup.value = resp.data?.signup || null;
            crud.clearLoading();
            return signup.value;
        } catch (e) {
            if (e.response?.status === 404) {
                signup.value = null;
                crud.clearLoading();
                return null;
            }
            crud.setError(e);
            return null;
        }
    }

    return {
        ...crud,
        firstName,
        lastName,
        email,
        phone,
        city,
        info,
        signup,
        fillFromUserSettings,
        clubSignUp,
        loadClubSignUp
    }
});
